module.exports = __webpack_public_path__ + "img/usersGreen.webp";